import Typography from "@mui/material/Typography"
import { observer } from "mobx-react-lite/dist"
import { useProposalsEditStore } from "../ProposalsEditStore"
import useStore from "reusable/mobx-store-utils"
import ProposalsEditServicesStore, { ProposalsEditServicesStoreProvider } from "./ProposalsEditServicesStore"
import Box from "@mui/material/Box"
import ServiceItem from "features/services/service-item/ServiceItem"
import ProposalsEditServicesSelect from "./ProposalsEditServicesSelect"
import ProposalsEditServicesList from "./ProposalsEditServicesList"
import Button from "@mui/material/Button"
import { useEffect } from "react"
import SkeletonLoader from "reusable/mui/skeleton/SkeletonLoader"

export default observer(function ProposalsEditServices() {
   const proposalsEditStore = useProposalsEditStore()
   const proposalsEditServicesStore = useStore(sp => new ProposalsEditServicesStore(sp), { proposalsEditStore })
   const serviceStore = proposalsEditServicesStore.sp.proposalsEditStore.sp.serviceStore

   useEffect(() => {
      if (serviceStore.services.length && !proposalsEditServicesStore.isInitialised) {
         proposalsEditServicesStore.initialiseSelectedServices()
      }
   }, [proposalsEditServicesStore, serviceStore.services])

   return (
      <ProposalsEditServicesStoreProvider store={proposalsEditServicesStore}>
         <Typography variant="h4">Add your services</Typography>
         <Typography variant="body1" sx={{ mt: 2 }}>Add and configure your services. You'll set pricing and payment options in the next step.</Typography>

         <Box sx={{ mt: 8 }}>
            <SkeletonLoader loading={!proposalsEditServicesStore.isInitialised}>
               <ProposalsEditServicesSelect />
            </SkeletonLoader>
            <ServiceItem source="proposals" />
         </Box>

         <Box sx={{ mt: 3 }}>
            <Box sx={{ textAlign: 'end' }}>
               <Button
                  sx={{ ...(proposalsEditServicesStore.isDragging ? {} : { display: 'none' }) }}
                  onClick={proposalsEditServicesStore.onStopReordering}>
                  Done reordering
               </Button>
            </Box>
            <ProposalsEditServicesList />
         </Box>

      </ProposalsEditServicesStoreProvider>
   );
})
